import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const BakerySolutionPage = () => {
  useEffect(() => {
    document.title = 'Pastane / Fırın Dijital Çözümü | QR Menü, POS, Online Sipariş, Yapay Zeka';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Pastane ve fırınlar için ürün planlama, vitrin–stok uyumu, online sipariş ve POS ile eksiksiz çözüm. QR Menü ücretsiz.');

    // Canonical
    const canonicalHref = `${siteUrl}/solutions/bakery`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Pastane/Fırın Dijital Çözümü',
      serviceType: 'Pastane Otomasyon Sistemi',
      areaServed: 'TR'
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Pastane / Fırın için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">Vitrin yönetimi, günlük üretim planı ve online sipariş akışını tek panelden kontrol edin. POS ile hızlı satış, AI ile talep tahmini.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>Günlük üretim planlama ve talep tahmini</li>
                <li>POS ile hızlı satış, çoklu yazıcı desteği</li>
                <li>Online sipariş ve teslimat akışı</li>
                <li>Etiket–alerjen yönetimi, QR Menü</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Pastane/Fırınlar için Modüller</h2>
            <p>Günlük üretim ve vitrin yönetimi, talep tahmini ve stok dengesiyle yakından ilişkilidir. Aşağıdaki modüllerle doğruluk ve hız sağlayın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">AI Destekli Talep Tahmini</h3>
            <p><a className="text-primary underline" href="/ai-system">AI</a> ile ürün bazında talep tahmini ve hazırlık planlaması yapın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">POS ve Hızlı Satış</h3>
            <p><a className="text-primary underline" href="/pos-system">POS</a> ile yoğun saatlerde hızlı satış, çoklu yazıcı ve kasa kapanışı yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş</h3>
            <p><a className="text-primary underline" href="/online-order">Online Sipariş</a> ile teslimat/gel‑al süreçlerini komisyonsuz yönetin.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">QR Menü</h3>
            <p><a className="text-primary underline" href="/qr-menu">QR Menü</a> ile alerjen ve ürün etiketleri göstererek satışa yönlendirin.</p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Talep tahmini nasıl çalışır?</summary>
                <p className="mt-2">Geçmiş satış verileri ve dönemsel trendler analiz edilerek öneriler sunulur.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Vitrin ile stok uyumunu nasıl sağlarım?</summary>
                <p className="mt-2">POS ve AI birlikte kullanılarak üretim planı ve vitrin eşleştirmesi önerilir.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default BakerySolutionPage;


